var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('el-main',[_c('p',[_vm._v("暂无权限，请联系管理员")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/login"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("返回登录页面")])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d6c7967","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/NoJurisdiction.vue
// module id = null
// module chunks = 